<!--列表文章-->
<template>
  <el-button-group>
    <el-button v-if="this.$fun.isQx(this.qx, 'news:add')" type="primary" icon="Plus" @click="addInfo">添加</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'news:del')" type="danger" icon="Delete" @click="delInfo">删除</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'news:enable')" type="success" icon="CircleCheck" @click="enableInfo(true)">启用</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'news:enable')" type="info" icon="CircleClose" @click="enableInfo(false)">禁用</el-button>
  </el-button-group>
  <div class="fun">
    <div class="search-div">
      <el-select v-model="searchNewsType" filterable clearable placeholder="请选择文章类型" class="width">
        <el-option
          v-for="item in newsTypeData" :key="item.value" :label="item.key" :value="item.value">
        </el-option>
      </el-select>
      <el-input placeholder="请输入关键字" prefix-icon="el-icon-search" v-model="searchKey" clearable class="width"></el-input>
      <el-date-picker v-model="searchDate" size="small" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" :default-time="defaultTime" value-format="x" clearable class="width1"></el-date-picker>
      <el-button type="primary" icon="search" @click="getData">查询</el-button>
    </div>
    <STC colName="newsColumn" :colList="colList" />
  </div>
  <el-table v-loading="tableLoading" :data="tableData" highlight-current-row stripe border
      :height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange"
      header-row-class-name="header-row" header-cell-class-name="header-cell">
    <el-table-column type="selection" width="40"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '文章标题')" prop="title" label="文章标题" show-overflow-tooltip>
      <template #default="scope">
        {{scope.row.title}}
      </template>
    </el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '文章类型')" prop="typeName" label="文章类型" width="100"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '保留(天)')" prop="keepDay" label="保留(天)" width="100"></el-table-column>
    <!-- <el-table-column prop="hit" label="点击数" width="90"></el-table-column> -->
    <el-table-column v-if="this.$fun.isExist(checkColList, '排序')" prop="queue" label="排序" width="60">
      <template #default="scope">
        <el-icon class="icon-cursor" @click="queueInfo(scope.row.id, false)"><SortDown /></el-icon>
        <el-icon class="icon-cursor" :title=scope.row.queue @click="queueInfo(scope.row.id, true)"><SortUp /></el-icon>
      </template>
    </el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '状态')" label="状态" width="60">
      <template #default="scope">
        <el-icon v-if="scope.row.isEnable" class="check" title="启用"><Check /></el-icon>
        <el-icon v-else class="close" title="禁用"><Close /></el-icon>
      </template>
    </el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '录入人')" prop="inputter" label="录入人" width="100"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '录入时间')" prop="upTime" label="录入时间" sortable width="150">
      <template #default="scope">
        <el-tooltip
          effect="dark"
          :disabled="scope.row.editTime === null"
          :content=scope.row.editTime
          placement="top">
          <span>{{scope.row.upTime}}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="操作" width="100">
      <template #default="scope">
        <el-button v-if="this.$fun.isQx(this.qx, 'news:edit')" text type="primary" @click="editInfo(scope.row.id)">修改</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
   :current-page="currentPage" :page-sizes="[10, 15, 20, 30, 40]"
   :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total='tableTotal'>
  </el-pagination>
  <!-- <el-dialog :title="dialogTitle" v-model="dialogFormVisible" :close-on-click-modal="false" :before-close="closeForm" append-to-body="true" width="81%">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
      <el-input v-model="form.id" type="hidden" class="none"></el-input>
      <el-form-item label="文章类型" prop="type">
        <el-select v-model="form.type" filterable clearable placeholder="请选择文章类型">
          <el-option
            v-for="item in newsTypeData" :key="item.value" :label="item.key" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文章标题" prop="title">
        <el-input v-model="form.title" maxlength="100" class="width6"></el-input>
      </el-form-item>
      <el-form-item label="简短标题" prop="shortTitle" class="flaot-left">
          <el-input v-model="form.shortTitle" maxlength="50" class="width3"></el-input>
      </el-form-item>
      <el-form-item label="文章摘要" prop="intro" class="clear">
        <el-input v-model="form.intro" type="textarea" rows=4 maxlength="500" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="文章内容" prop="content">
        <vue-tinymce v-model="form.content" :content="htmlContent" :setting="setting" />
      </el-form-item>
      <el-form-item label="保留天数">
        <el-input-number v-model="form.keepDay" :min="0" />&nbsp;
        <el-tooltip effect="customized">
          <template #content>通知公告发布后标题在主页面上保留的天数。</template>
          <el-icon :size="16"><InfoFilled /></el-icon>
        </el-tooltip>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;排序(降序)&nbsp;
        <el-input-number v-model="form.queue" :min="0" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeForm">关 闭</el-button>
        <el-button @click="resetForm">重 填</el-button>
        <el-button type="primary" @click="saveInfo">确 定</el-button>
      </span>
    </template>
  </el-dialog> -->

  <div v-if="dialogFormVisible" class="modal-mask">
    <div class="modal-dialog">
      <div class="dialog-top">
        <span>{{dialogTitle}}</span>
        <el-icon @click="closeForm"><close /></el-icon>
      </div>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
        <el-input v-model="form.id" type="hidden" class="none"></el-input>
        <el-form-item label="文章类型" prop="type">
          <el-select v-model="form.type" filterable clearable placeholder="请选择文章类型">
            <el-option
              v-for="item in newsTypeData" :key="item.value" :label="item.key" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文章标题" prop="title">
          <el-input v-model="form.title" maxlength="100" class="width6"></el-input>
        </el-form-item>
        <el-form-item label="简短标题" prop="shortTitle" class="flaot-left">
            <el-input v-model="form.shortTitle" maxlength="50" class="width3"></el-input>
        </el-form-item>
        <el-form-item label="文章摘要" prop="intro" class="clear">
          <el-input v-model="form.intro" type="textarea" rows=4 maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="文章内容" prop="content">
          <vue-tinymce v-model="form.content" :content="htmlContent" :setting="setting" />
        </el-form-item>
        <el-form-item label="保留天数">
          <el-input-number v-model="form.keepDay" :min="0" />&nbsp;
          <el-tooltip effect="customized">
            <template #content>通知公告发布后标题在主页面上保留的天数。</template>
            <el-icon :size="16"><InfoFilled /></el-icon>
          </el-tooltip>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;排序(降序)&nbsp;
          <el-input-number v-model="form.queue" :min="0" />
        </el-form-item>
      </el-form>
      <div class="dialog-botton">
        <el-button @click="closeForm">关 闭</el-button>
        <el-button @click="resetForm">重 填</el-button>
        <el-button type="primary" @click="saveInfo">确 定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 选择显示的表列
import STC from '@/components/SelectTableColumn'
export default {
  name: 'news',
  components: {
    STC
  },
  data () {
    return {
      qx: '',
      colList: ['文章标题', '文章类型', '保留(天)', '排序', '状态', '录入人', '录入时间'],
      checkColList: [],
      tableLoading: false,
      currentPage: 1,
      pagesize: 15,
      tableTotal: 0,
      tableData: [],
      selectionIds: '',
      dialogFormVisible: false,
      dialogTitle: '',
      form: {
        id: '',
        type: '',
        title: '',
        shortTitle: '',
        intro: '',
        content: '',
        keepDay: 7,
        queue: 0
      },
      rules: {
        type: [
          { required: true, message: '请选择文章类型', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ]
      },
      // 是否可点击
      disabled: false,
      htmlContent: '',
      setting: {
        menubar: false,
        toolbar: 'code undo redo | removeformat preview fullscreen searchreplace | alignleft aligncenter alignright alignjustify indent outdent lineheight | bold italic underline strikethrough hr link unlink | numlist bullist | image media table emoticons charmap | formatselect fontselect fontsizeselect forecolor backcolor | superscript subscript | bdmap help |',
        toolbar_drawer: 'sliding',
        // quickbars_selection_toolbar: 'removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor',
        plugins: 'code link image media table emoticons charmap lists advlist fullscreen lineheight hr quickbars bdmap searchreplace preview help',
        images_upload_url: this.$api.upimage1,
        images_upload_base_path: process.env.VUE_APP_URL,
        branding: false,
        language: 'zh_CN',
        height: 500,
        content_style: 'img {max-width:100%;}',
        file_picker_types: 'file,image,media',
        // 取消相对路径
        relative_urls: false,
        // convert_urls: false,
        file_picker_callback: (callback, value, meta) => {
          var filetype = '.pdf, .txt, .zip, .rar, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .mp3, .mp4, .flv, .avi'
          // 后端接收上传文件的地址
          // var homeurl = this.$api.homeUrl
          var homeurl = process.env.VUE_APP_URL
          var upurl
          // 为不同插件指定文件类型及后端地址
          switch (meta.filetype) {
            case 'image':
              filetype = '.jpg, .jpeg, .png, .gif'
              upurl = this.$api.upimage
              break
            case 'media':
              filetype = '.mp3, .mp4'
              upurl = this.$api.upmedia
              break
            case 'file':
              upurl = this.$api.upfile
              break
            default:
          }
          var input = document.createElement('input')
          input.setAttribute('type', 'file')
          input.setAttribute('accept', filetype)
          input.click()
          input.onchange = async fn => {
            var file = fn.path[0].files[0]
            const fd = new FormData()
            fd.append('files', file)
            // console.log('file', file)
            if (meta.filetype === 'image') {
              const isLt2M = file.size / 1024 / 1024 < 2
              if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!')
                return
              }
            } else {
              const isLt2M = file.size / 1024 / 1024 < 10
              if (!isLt2M) {
                this.$message.error('上传文件大小不能超过 10MB!')
                return
              }
            }
            const { data: ret } = await this.$http.post(upurl, fd)
            if (ret.status === 0) {
              this.$message.success(ret.message)
              var backurl = homeurl + ret.data
              callback(backurl)
            } else {
              this.$message.error(ret.message)
            }
          }
        }
      },
      searchKey: '',
      searchDate: '',
      searchNewsType: '',
      newsTypeData: [],
      defaultTime: ([
        new Date(2000, 1, 1, 0, 0, 0),
        new Date(2000, 2, 1, 23, 59, 59)
      ])
    }
  },
  // 接收父组件传值
  props: ['clientHeight'],
  mounted () {
    this.qx = this.$route.params.qx
    // const ui = this.$api.ui
    // if (ui == null) {
    //   this.$router.push({ path: '/login' })
    // }
    this.getTableHeight()
    // this.$route.params.sid this.$route.query.sid
    this.getData()
    this.getNewsTypeData()
  },
  methods: {
    // pageSize 新每页条数改变时触发(每页下拉显示数据)
    handleSizeChange (size) {
      this.pagesize = size
      this.getData()
    },
    // 新当前页改变时触发(点击第几页)
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getData()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.selectionIds = ''
      for (var i = 0; i < val.length; i++) {
        if (this.selectionIds === '') {
          this.selectionIds = val[i].id
        } else {
          this.selectionIds += ',' + val[i].id
        }
      }
    },
    async getData () {
      this.tableLoading = true
      const params = '?type=' + this.searchNewsType + '&key=' + this.searchKey + '&date=' + this.searchDate + '&pagesize=' + this.pagesize + '&pageindex=' + this.currentPage
      const { data: ret } = await this.$http.get(this.$api.newslist + params)
      if (ret.status === 0) {
        this.tableData = ret.data.rows
        this.tableTotal = ret.data.total
      }
      this.tableLoading = false
    },
    async getNewsTypeData () {
      const { data: ret } = await this.$http.get(this.$api.dictItemListByCode + '?code=news-type')
      // console.log('typeret=', ret)
      if (ret.status === 0) {
        if (ret.data === null) {
          this.$message({
            message: ret.message,
            type: 'warning'
          })
          return
        }
        this.newsTypeData = ret.data
      }
    },
    addInfo () {
      this.dialogTitle = '添加文章内容'
      this.dialogFormVisible = true
      this.form.id = ''
    },
    async getNewsInfo (id) {
      const { data: ret } = await this.$http.get(this.$api.newsid + '/' + id)
      if (ret.status === 0 && ret.data !== null) {
        const obj = ret.data
        Object.keys(this.form).forEach(key => {
          this.form[key] = obj[key]
        })
        this.htmlContent = this.form.content
        this.dialogTitle = '修改文章内容'
      } else {
        this.$message.error(ret.message)
      }
    },
    async editInfo (id) {
      this.dialogFormVisible = true
      // const loading = this.$loading({
      //   lock: true,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
      setTimeout(() => {
        this.getNewsInfo(id)
      }, 1000)
      // loading.close()
    },
    saveInfo () {
      this.form.content = this.$tinymce.activeEditor.getContent()
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          console.log('this.form=', this.form)
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const { data: ret } = await this.$http.post(this.$api.newssave, this.form)
          if (ret.status === 0) {
            this.$message.success(ret.message)
            this.getData()
            this.closeForm()
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    delInfo () {
      if (this.selectionIds === '') {
        this.$message.error('请选择将删除的信息。')
        return
      }
      this.$confirm('此操作将删除已选择的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const { data: ret } = await this.$http.post(this.$api.newsdel + '?ids=' + this.selectionIds)
        if (ret.status === 0) {
          this.getData()
          this.$message.success(ret.message)
        } else {
          this.$message.error(ret.message)
        }
        loading.close()
      })
    },
    async enableInfo (bo) {
      const s = bo ? '启用' : '禁用'
      if (this.selectionIds === '') {
        this.$message.error('请选择将' + s + '的信息。')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?ids=' + this.selectionIds + '&bo=' + bo
      const { data: ret } = await this.$http.post(this.$api.newsenable + params)
      if (ret.status === 0) {
        this.getData()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    async queueInfo (id, bo) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?id=' + id + '&bo=' + bo
      const { data: ret } = await this.$http.post(this.$api.newsqueue + params)
      if (ret.status === 0) {
        this.getData()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    resetForm () {
      this.$refs.formRef.resetFields()
      this.form.content = ''
      this.form.queue = 0
      this.htmlContent = ''
    },
    closeForm () {
      this.resetForm()
      this.dialogFormVisible = false
    },
    getTableHeight () {
      this.tableHeight = this.clientHeight - 88 - 42 - 35
    }
  },
  watch: {
    clientHeight: function (val) {
      this.getTableHeight()
    }
  }
}
</script>

<style lang="less" scoped>
  .pic-collapse{
    display:none;
  }
  .uploaderPic {
    width: 250px;
    height: 80px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background-color:#F5F7FA;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 250px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar {
    width: 250px;
    height: 80px;
    display: block;
  }
  .el-upload-list__item-actions {
    width: 250px;
    height: 80px;
    position: absolute;
    top: 0;
    display: flex;
    cursor: default;
    align-items: center;
    justify-content: space-around;
    visibility: hidden;
    background: rgba(0, 0, 0, 0.3);
  }
  .el-form-item__content:hover .el-upload-list__item-actions {
    visibility: visible;
    transition: 1s;
  }
  .el-upload-list__item-preview {
    display: inline-block;
    width: 30px;
    height: 30px;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    .el-icon-zoom-in:before,
    .el-icon-delete:before {
      font-size: 20px;
      color: #fff;
    }
  }

  .modal-mask {
    display: flex;
    justify-content: center;
    align-items: center;
    position:fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 100;
    overflow: auto;
  }
  .modal-dialog {
    margin-top: 350px;
    margin-bottom: 50px;
    width: 80%;
    background: #fff;
    border-radius: 3px;
  }
  .dialog-top {
    display:flex;
    justify-content:space-between;
    align-items: center;
    padding: 20px;
    font-size: 20px;
    .el-icon{
      cursor: pointer;
    }
  }
  .dialog-botton {
    padding: 20px;
    text-align: right;
  }
  .el-form {
    padding: 10px 30px 10px 0;
  }
</style>
